'use strict';

angular.module('licensure.services')
    .factory('DocumentTypes', ['$http', '$q', function ($http, $q) {
        var get = function (args) {
            var d = $q.defer();

            $http.get(apiLocation + '/api/documenttypes', {
                params: args
            })
                .then(function (response) {
                    d.resolve(response.data);
                })
                .catch(function (response) {
                    console.log(response.data);
                    // handle error
                });

            return d.promise;
        }

        var getOtherDocuments = function (args) {
            var d = $q.defer();

            $http.get(apiLocation + '/api/Core/OtherDocumentTypes', {
                params: args
            })
                .then(function (response) {
                    d.resolve(response.data);
                })
                .catch(function (response) {
                    console.log(response.data);
                    // handle error
                });

            return d.promise;
        }

        return {
            get: get,

            getOtherDocuments: getOtherDocuments,

            getDisplayApplicant: function () {
                return get({ display_applicant: true })
            },

            getForForm: function () {
                return get({ display_form: true });
            }
        }
    }])
;